<template>
    <div class="container">
        <div class="head">
            <div class="name">{{targetDetail.name}}</div>
            <div class="card-area">
                <div class="card">
                    <div class="card-name">正在告警</div>
                    <div class="card-val">{{targetDetail.alarm_waiting_handle_count}}</div>
                </div>
                <div class="card">
                    <div class="card-name">告警项</div>
                    <div class="card-val">{{targetDetail.alarm_total_count}}</div>
                </div>
            </div>
        </div>
        <div class="tab-area">
            <el-tabs v-model="activeName" type="card">
                <el-tab-pane label="告警记录" name="first">
                    <alarm-record :project-id="projectId" v-if="componentReset"></alarm-record>
                </el-tab-pane>
                <el-tab-pane label="告警配置" name="second">
                    <alarm-configuration :project-id="projectId" v-if="componentReset"></alarm-configuration>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import Core from '../../core'
import AlarmRecord from './components/AlarmRecord';
import AlarmConfiguration from './components/AlarmConfiguration';

export default {
    components: {
        AlarmRecord,
        AlarmConfiguration,
    },
    props: {},
    data() {
        return {
            activeName: 'first',
            projectId: '',
            targetDetail: {},
            componentReset: true
        };
    },
    watch: {
        activeName() {
            this.componentReset = false
            this.$nextTick(() => {
                this.componentReset = true
            })
        }
    },
    computed: {},
    created() {
        this.projectId = this.$route.query.project_id
    },
    mounted() {
        this.initTargetDetail()
    },
    methods: {
        initTargetDetail() {
            Core.Api.Project.detail(this.projectId).then(res => {
                this.targetDetail = res.project
            })
        },
    }
};
</script>
<style lang="scss" scoped>
.container {
    background: #f1f4f9;
    .head {
        width: 100%;
        background: #fff;
        color: rgba(26, 41, 64, 1);
        box-sizing: border-box;
        padding: 0 25px 20px 25px;
        .name {
            font-size: 18px;
            font-weight: 500;
            padding: 14px 0;
        }
        .card-area {
            display: flex;
            .card {
                width: 190px;
                height: 66px;
                background: rgba(247, 249, 251, 1);
                border-radius: 4px;
                box-sizing: border-box;
                padding: 11px 14px;
                margin-right: 10px;
                .card-name {
                    font-size: 12px;
                    color: rgba(165, 172, 184, 1);
                }
                .card-val {
                    font-size: 18px;
                    font-weight: 500;
                    color: rgba(26, 41, 64, 1);
                }
            }
        }
    }
}
</style>